"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeletingSystemComponentSelector = exports.isDeleteAssociationDialogOpenSelector = exports.rowIndexToBeRemovedSelector = exports.componentToBeUnlinkedSelector = exports.isPromptVisibleSelector = exports.selectedSystemNameSelector = exports.autoCompleteOptionsSelector = exports.systemComponentsSelector = exports.areSystemComponentsLoadingSelector = void 0;
const reselect_1 = require("reselect");
const selectors_1 = require("@/store/ducks/components/selectors");
const areSystemComponentsLoadingSelector = (state) => {
    return state.systemComponents.areSystemComponentsLoading;
};
exports.areSystemComponentsLoadingSelector = areSystemComponentsLoadingSelector;
const systemComponentsSelector = (state) => {
    return state.systemComponents.systemComponents.map((component) => ({
        name: component.name,
        id: component.id,
        order: component.order,
        unit: component.unit,
        range: {
            lowLimitValue: component.lowValueLimit,
            highLimitValue: component.highValueLimit,
        },
    }));
};
exports.systemComponentsSelector = systemComponentsSelector;
exports.autoCompleteOptionsSelector = (0, reselect_1.createSelector)(selectors_1.componentTableRowsSelector, exports.systemComponentsSelector, (components, systemComponents) => {
    return components.map((component) => {
        const equivalentComponent = systemComponents.find((systemComponent) => systemComponent.id === component.id);
        return {
            name: component.name,
            id: component.id,
            order: component.order,
            unit: component.unit,
            range: {
                lowLimitValue: equivalentComponent?.range?.lowLimitValue,
                highLimitValue: equivalentComponent?.range.highLimitValue,
            },
        };
    });
});
const selectedSystemNameSelector = (state) => {
    return state.systemComponents.selectedSystemName;
};
exports.selectedSystemNameSelector = selectedSystemNameSelector;
const isPromptVisibleSelector = (state) => {
    return state.systemComponents.isSavePromptVisible;
};
exports.isPromptVisibleSelector = isPromptVisibleSelector;
const componentToBeUnlinkedSelector = (state) => {
    return state.systemComponents.componentToBeRemoved;
};
exports.componentToBeUnlinkedSelector = componentToBeUnlinkedSelector;
const rowIndexToBeRemovedSelector = (state) => {
    return state.systemComponents.rowIndexToBeUnlinked;
};
exports.rowIndexToBeRemovedSelector = rowIndexToBeRemovedSelector;
const isDeleteAssociationDialogOpenSelector = (state) => {
    return state.systemComponents.isDeleteAssociationModalOpen;
};
exports.isDeleteAssociationDialogOpenSelector = isDeleteAssociationDialogOpenSelector;
const isDeletingSystemComponentSelector = (state) => {
    return state.systemComponents.isDeletingAssociation;
};
exports.isDeletingSystemComponentSelector = isDeletingSystemComponentSelector;
